import React, { useEffect, useCallback, useState } from 'react';
import { useSelector } from "react-redux"
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { ENDPOINT } from "constants/variables";
import Box from '@mui/material/Box'; 
import Checkbox from '@mui/material/Checkbox';
import Container from '@mui/material/Container'; 
import TextField from '@mui/material/TextField'; 
import SwipeableDrawer from '@mui/material/SwipeableDrawer'; 
import { warningErrorAction } from "actions/ErrorActions"; 
import { helpHttp } from "service/HelpHttp";
import "css/employeeHeader.css";
import "css/customDialog.css"; 
import PropTypes from 'prop-types'; 

const initialVehicle = {
  "id":"",
  "indexrowtrailer":0,
  "licenseplate" : "",
  "enabled" : true,
  "vehicletrailerstore_store_id" : 0,
  "vehicletrailerstore_store_tradename" : ""
 };

const StoreCreateOrEditTrailer = ({openEditRowVehicleTrailer,setOpenEditRowVehicleTrailer,openEditNewVehicleTrailer,setOpenEditNewVehicleTrailer,formStore,setFormStore,editRowVehicleTrailer,setEditRowVehicleTrailer}) => {
  const {t } = useTranslation(['listDataStores']);
  const token = useSelector((state) => state.loginUser.token); 
  const [newVehicleTrailer,setNewVehicleTrailer]= useState(initialVehicle);
  const [errorsVehicleTrailer, setErrorsVehicleTrailer] = useState({});
  const [foundLicensePlate, setFoundLicensePlate ]= useState(false);  
  const [trailersToSelect, setTrailersToSelect] = useState([]);
  const dispatch = useDispatch();
 
  const keyPress = useCallback(
    e => {
      if (e.key === 'Escape' && openEditRowVehicleTrailer) {
        setNewVehicleTrailer(initialVehicle);
        setErrorsVehicleTrailer({});
        setEditRowVehicleTrailer(initialVehicle);
        setOpenEditNewVehicleTrailer(false);
        setOpenEditRowVehicleTrailer(false);
        setFoundLicensePlate(false);
      }
    },[
      setNewVehicleTrailer,
      setErrorsVehicleTrailer,
      openEditRowVehicleTrailer,
      setOpenEditRowVehicleTrailer,
      setOpenEditNewVehicleTrailer,
      setFoundLicensePlate,
      setEditRowVehicleTrailer]
  );

  const handleClosenewVehicleTrailer = () => {
    setNewVehicleTrailer(initialVehicle);
    setErrorsVehicleTrailer({});
    setEditRowVehicleTrailer(initialVehicle);
    setOpenEditNewVehicleTrailer(false);
    setOpenEditRowVehicleTrailer(false);
    setFoundLicensePlate(false);
    setTrailersToSelect([]);
  };
  
  const handleChangenewVehicleTrailer = (e) => {
    const { name, value } = e.target;
    setNewVehicleTrailer(newVehicleTrailer => ({
      ...newVehicleTrailer,
      [name]: value,
    }));   
  };
  
  const handleBlurnewVehicleTrailer = (e) => {
    handleChangenewVehicleTrailer(e);
    setErrorsVehicleTrailer(validateFormVehicle());
  };
  
  const handleChangeEnabledVehicle = () => {
    setNewVehicleTrailer(newVehicleTrailer => ({
      ...newVehicleTrailer,
      enabled: !newVehicleTrailer.enabled
    }));
  };
 
  const toggleDrawernewVehicleTrailer  = (open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    if (event.type === 'keydown') {
      handleClosenewVehicleTrailer();
    }
  };

  const validateFormVehicle = () => {
    let errorsVehicleTrailer = {};
    let regexInvalidCharacters = /[\\!\\$\\%\\&\\|\\<\\>\\?\\{\\}\\~\\"\\']+/;

    if (newVehicleTrailer.licenseplate===""){
        errorsVehicleTrailer.licenseplate = 'TextLicensePlateRequired';
    }else{
      if (regexInvalidCharacters.test(newVehicleTrailer.licenseplate)) {
        errorsVehicleTrailer.licenseplate = 'Text_TextNoValid';
      } if (foundLicensePlate){
        errorsVehicleTrailer.licenseplate='TextTrailer_LicensePlateExist_other';
      }
    }
    if (!openEditNewVehicleTrailer){
      if (formStore.trailers.find(item => {return (item.licenseplate.trim()=== newVehicleTrailer.licenseplate.trim()) })){
        errorsVehicleTrailer.licenseplate = 'TextTrailer_LicensePlateExist';
      }
    }else{
      if (formStore.trailers.find((item, index) => {return (item.indexrowtrailer!==newVehicleTrailer.indexrowtrailer && item.licenseplate.trim()=== newVehicleTrailer.licenseplate.trim()  ) })){
        errorsVehicleTrailer.licenseplate = 'TextTrailer_LicensePlateExist';
      }
    }  
    return errorsVehicleTrailer;
  };

  const handleSubmitnewVehicleTrailer = () => {   
    setErrorsVehicleTrailer(validateFormVehicle());
    let errorsCheckVehicle=validateFormVehicle();

    if ((Object.keys(errorsCheckVehicle).length === 0) 
          && newVehicleTrailer.licenseplate!=='' ) {

      let vehicleToAdd={
        "id":newVehicleTrailer.id,
        "indexrowtrailer":openEditNewVehicleTrailer?newVehicleTrailer.indexrowtrailer:formStore.trailers.length>0?formStore.trailers[formStore.trailers.length-1].indexrowtrailer+1:1,       
        "licenseplate":newVehicleTrailer.licenseplate,
        "enabled":newVehicleTrailer.enabled,
        "vehicletrailerstore_store_id" : newVehicleTrailer.vehicletrailerstore_store_id,
        "vehicletrailerstore_store_tradename" :newVehicleTrailer.vehicletrailerstore_store_tradename
      }
       
      if (!openEditNewVehicleTrailer){
        formStore.trailers.push(vehicleToAdd);
      }else{
        let idx=formStore.trailers.findIndex(((item) => item.indexrowtrailer === newVehicleTrailer.indexrowtrailer));
        formStore.trailers[idx]=vehicleToAdd
      }
      setFormStore(formStore => ({
        ...formStore,
      }))
      handleClosenewVehicleTrailer();
    } else {
      if (errorsCheckVehicle.licenseplate){
        dispatch(warningErrorAction(t(errorsCheckVehicle.licenseplate)));
      }
    }  
  };

  useEffect(() => {
    let isMounted = true;
    const fetchDataTrailers = async () => {
      try {
        const getData = await helpHttp().get(ENDPOINT, `vehiclestrailers/getlisvehiclestrailers`, token);
        if (getData.err) {
          dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else if (isMounted) {
          const licenseplate = newVehicleTrailer.licenseplate.toUpperCase();
          setTrailersToSelect(getData.filter((trailer) =>
            trailer.vehicletrailerstore_licenseplate?.toUpperCase().includes(licenseplate)
            && trailer.id !== newVehicleTrailer.id
          ));
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData')));
      }
    };
    if (openEditRowVehicleTrailer && newVehicleTrailer.licenseplate) {
      fetchDataTrailers();
    } else {
      setTrailersToSelect([]);
    }
    return () => { isMounted = false };
  }, [t, token, dispatch, newVehicleTrailer.id, newVehicleTrailer.licenseplate, openEditRowVehicleTrailer]);

  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event && typeof event === 'object' && event.key) {
        keyPress(event);
      }
    };
    document.addEventListener('keydown', handleKeyPress);
    return () => {
      document.removeEventListener('keydown', handleKeyPress);
    };
  }, [keyPress]);

  useEffect(() => {
    let isMounted = true; 
    const fetchExistLicensePlate = async () => {
      try {
        const getData = await helpHttp().get2(ENDPOINT,`store/getexixtslicenseplatetrailer/`,token,
            (newVehicleTrailer.licenseplate!==undefined && newVehicleTrailer.licenseplate!==null && newVehicleTrailer.licenseplate.replace(/[.\-/\\|]/g, "").trim()!=="")?newVehicleTrailer.licenseplate.replace(/[.\-/\\|]/g, "").trim():"-1"); 
        if (getData.err) {
            dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else if (isMounted) {
            setFoundLicensePlate(getData!==newVehicleTrailer.id && getData>0)
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    };  
  
    if (newVehicleTrailer.licenseplate && newVehicleTrailer.licenseplate.replace(/[.\-/\\|]/g, "").trim()!=="") { 
      fetchExistLicensePlate();
    }
    return () => { isMounted = false };
  }, [t,token,dispatch,newVehicleTrailer.licenseplate,newVehicleTrailer.id]); 

  useEffect(() => {
    let isMounted = true;
    if (isMounted && openEditNewVehicleTrailer){
      setNewVehicleTrailer(newVehicleTrailer => ({
        ...newVehicleTrailer,
        id:editRowVehicleTrailer.id!==null?editRowVehicleTrailer.id:"",
        indexrowtrailer:editRowVehicleTrailer.indexrowtrailer!==null?editRowVehicleTrailer.indexrowtrailer:"",
        licenseplate:editRowVehicleTrailer.licenseplate!==null?editRowVehicleTrailer.licenseplate:"",
        enabled:editRowVehicleTrailer.enabled!==null?editRowVehicleTrailer.enabled:true,
        vehicletrailerstore_store_id : editRowVehicleTrailer.vehicletrailerstore_store_id!==null?editRowVehicleTrailer.vehicletrailerstore_store_id:0,
        vehicletrailerstore_store_tradename : editRowVehicleTrailer.vehicletrailerstore_store_tradename!==null?editRowVehicleTrailer.vehicletrailerstore_store_tradename:"",
      }));
    }
    return()=>{isMounted=false;}   
  },[editRowVehicleTrailer,openEditNewVehicleTrailer]);

  return(
    <>
      {openEditRowVehicleTrailer && 
        <div>
          <SwipeableDrawer
            anchor='right'
            open={true}
            onClose={toggleDrawernewVehicleTrailer(false)}
            onOpen={toggleDrawernewVehicleTrailer(true)}>
            <Container >
              <Box sx={{ bgcolor: '#ffffff',height:'100vh', width: '500px' }}>
                <br/>
                <div id="myDIV">
                  <h1 className="h1NewStyle px-4 mb-2">{openEditNewVehicleTrailer?t('Text_VehicleTrailer_Edit'):t('Text_VehicleTrailer_New')}</h1>
                </div>  
                <hr className="sidebar-divider d-none d-md-block"/>
                <form className="createVehicle" onSubmit={handleClosenewVehicleTrailer}>  
                  <div className="form-floating mb-3 px-4 primary">
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_Trailer_licenseplate')} :</label>
                    <div className="form-group">
                      <TextField
                        id="licenseplate" 
                        name="licenseplate"
                        value={newVehicleTrailer.licenseplate}
                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                        inputProps={{ style: {width: 450, fontSize: '18px'}, maxLength: 50 }} 
                        label={errorsVehicleTrailer.licenseplate!=null?t(errorsVehicleTrailer.licenseplate):t('PlaceHolder_Trailer_licenseplate')}
                        placeholder={t('PlaceHolder_Trailer_licenseplate')}
                        variant="standard"
                        onBlur={handleBlurnewVehicleTrailer}
                        onChange={handleChangenewVehicleTrailer}/>
                      {trailersToSelect.length > 0 && (
                        <div className="dropdown-class" style={{ position: 'absolute', zIndex: 1301, width: 450, maxHeight: 220, overflowY: 'auto', background: '#fff', boxShadow: '0 4px 12px rgba(0,0,0,.2)' }}>
                          {trailersToSelect.map((trailer) => (
                            <button
                              key={trailer.id}
                              type="button"
                              style={{ display: 'block', width: '100%', padding: '10px 14px', border: 0, background: '#fff', textAlign: 'left', cursor: 'pointer' }}
                              onMouseDown={(event) => event.preventDefault()}
                              onClick={() => {
                                setNewVehicleTrailer((current) => ({
                                  ...current,
                                  id: trailer.id,
                                  licenseplate: trailer.vehicletrailerstore_licenseplate
                                }));
                                setFoundLicensePlate(false);
                                setTrailersToSelect([]);
                              }}>
                              {trailer.vehicletrailerstore_licenseplate}
                            </button>
                          ))}
                        </div>
                      )}
                    </div>
                     <div className="form-group">
                      <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_Vehicle_enabled')} :</label>
                      <Checkbox  
                        checked={newVehicleTrailer.enabled} 
                        onChange={handleChangeEnabledVehicle} 
                        sx={{
                          '& .MuiSvgIcon-root': { color:"#4e73df",fontSize: 28 }, // Ajusta el tamaño del ícono
                        }}
                      />
                    </div>
                    <hr className="sidebar-divider d-none d-md-block" />
                    <div className="formdi-pending-action-group">
                      <button className="formdi-pending-action-btn formdi-pending-action-btn--primary" type="button"  onClick={handleSubmitnewVehicleTrailer}>
                        {openEditNewVehicleTrailer?t('Button_Update'):t('Button_Create')}
                      </button> 
                      <button className="formdi-pending-action-btn formdi-pending-action-btn--secondary" type="button" onClick={handleClosenewVehicleTrailer}>
                        {t('Button_Cancel')}
                      </button>
                    </div>  
                  </div>
                </form>
              </Box>
            </Container>
          </SwipeableDrawer>
        
        </div>
      }   
    </>
  )
}

StoreCreateOrEditTrailer.propTypes = {
  openEditRowVehicleTrailer: PropTypes.bool.isRequired,
  setOpenEditRowVehicleTrailer: PropTypes.func.isRequired,
  openEditNewVehicleTrailer: PropTypes.bool.isRequired,
  setOpenEditNewVehicleTrailer: PropTypes.func.isRequired,
  formStore: PropTypes.object.isRequired,
  setFormStore: PropTypes.func.isRequired,
  setEditRowVehicleTrailer: PropTypes.func.isRequired
};

export default StoreCreateOrEditTrailer;
